import { render, staticRenderFns } from "./RunnitCarousel.vue?vue&type=template&id=55e5b7fd&scoped=true"
import script from "./RunnitCarousel.vue?vue&type=script&lang=ts"
export * from "./RunnitCarousel.vue?vue&type=script&lang=ts"
import style0 from "./RunnitCarousel.vue?vue&type=style&index=0&id=55e5b7fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e5b7fd",
  null
  
)

export default component.exports